import { render, staticRenderFns } from "./dropper_item.vue?vue&type=template&id=faef8992&scoped=true&"
import script from "./dropper_item.vue?vue&type=script&lang=js&"
export * from "./dropper_item.vue?vue&type=script&lang=js&"
import style0 from "./dropper_item.vue?vue&type=style&index=0&id=faef8992&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faef8992",
  null
  
)

export default component.exports